export const getSlideLayout = (slide) => {
  const baseClasses = "flex h-full w-full";

  // Layout type handling
  switch (slide.layout?.type) {
    case "center-right":
      return `
        ${baseClasses} 
        flex-col 
        items-start 
        justify-center 
        mtext-left 
        ${slide.layout.padding || "pb-10 pl-10"} 
        ${slide.layout.spacing || "space-y-4"}
        `;
    case "center-right-mobile":
      return `
        ${baseClasses} 
        flex-col 
        md:items-start 
        items-center
        justify-center 
        md:text-left 
        text-center
        ${slide.layout.padding || "pb-10 pl-10"} 
        ${slide.layout.spacing || "space-y-4"}
        `;

    case "center-left":
      return `
      ${baseClasses} 
        flex-col 
        items-start 
        justify-center  
        text-left 
        ${slide.layout.padding || "pb-24 pl-20"} 
        ${slide.layout.spacing || "space-y-4"}
      `;
    case "top-left":
      return `
        ${baseClasses} 
        flex-col 
        items-start 
        justify-start
        text-left 
        ${slide.layout.padding || "pb-24 pl-20"} 
        ${slide.layout.spacing || "space-y-4"}
        `;
    case "bottom-center":
      return `
          ${baseClasses} 
          flex-col 
          items-center 
          !justify-end  // Changed from justify-center
          text-center 
          ${slide.layout.padding || "pb-12"} // Added default bottom padding
          ${slide.layout.spacing || "space-y-4"}
          `;
    case "bottom-right":
      return `${baseClasses} \
              ${baseClasses} 
              flex-col 
              items-end 
              justify-end 
              text-left 
              ${slide.layout.padding || "pb-10 pl-10"} 
              ${slide.layout.spacing || "space-y-4"}
            }`;

    case "bottom-right-mobile":
      return `${baseClasses} \
                      ${baseClasses} 
                      flex-col 
                      md:items-end items-start
                      justify-end 
                      text-left 
                      ${slide.layout.padding || "pb-10 pl-10"} 
                      ${slide.layout.spacing || "space-y-4"}
                    }`;

    default: // centered
      return `
          ${baseClasses} 
          ${slide.layout?.verticalPos || "items-center"} 
          ${slide.layout?.horizontalPos || "justify-center"} 
          ${slide.layout?.textAlign || "text-center"} 
          ${slide.layout?.padding || ""}
        `;
  }
};
